__turbopack_context__.v({
  "content": "sLwwzG_content",
  "dialogBannerWrapper": "sLwwzG_dialogBannerWrapper",
  "footer": "sLwwzG_footer",
});
